import { DateTime } from 'luxon';
import { Location } from '../../types/api';
import { DATE_MODIFIERS } from './constants';

export const validateLocations = (locations: Location[]): Location[] => {
	return locations.filter((location) => {
		const { onSaleStart, onSaleEnd, durationValue, durationUnit } =
			location.locationMetadata || {};
		const today = DateTime.now().startOf('day');

		const defaultStart = today.plus({
			days: DATE_MODIFIERS.holidaysStartDays
		});
		const defaultEnd = defaultStart.plus({
			months: DATE_MODIFIERS.holidaysEndMonths
		});

		let startDate = onSaleStart ? DateTime.fromISO(onSaleStart) : defaultStart;
		let endDate = onSaleEnd ? DateTime.fromISO(onSaleEnd) : defaultEnd;

		if (durationValue && durationUnit) {
			let duration = {};
			switch (durationUnit) {
				case 'd':
					duration = { days: durationValue };
					break;
				case 'w':
					duration = { weeks: durationValue };
					break;
				case 'm':
					duration = { months: durationValue };
					break;
				case 'y':
					duration = { years: durationValue };
					break;
				default:
					return false;
			}

			if (Object.keys(duration).length > 0) {
				endDate = startDate.plus(duration);

				if (endDate < today) {
					startDate = defaultStart;
					endDate = defaultEnd;
				}
			}
		}

		if (endDate < today || startDate > endDate) {
			return false;
		}

		return true;
	});
};
